export class StructureDocument {
    generated: boolean = false;
    date: Date;

    loadData(r: any) {
        if (r.generated)
            this.generated = r.generated
        if (r.date)
            this.date = r.date
    }
}




// WEBPACK FOOTER //
// ./src/app/models/StructureDocument.model.ts